const apiUrl = process.env.REACT_APP_API_URL;
export const PostInscripcioIdValidar = async ( idInst: string, estat: string, page : string) => {
    try {
        const response = await fetch(`${apiUrl}:8073/inscripcions/${idInst}/validar/${estat}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page
            }
        });
        if (!response.ok) {
            console.log(await response.text());
        }
    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
